import React from "react";
import Image from "next/image";

import CardWidget from "../ui/Widget/CardWidget";
import { trpc } from "@utils";
import { Spin } from "antd";
import { PopupCard } from "@ui";
import Button from "antd/lib/button";
import { useNotification } from "hooks/useNotification";
import { ArrowPathIcon } from "@heroicons/react/24/solid";

export const RequestConnectionWidget = () => {
    const notify = useNotification();
    const { data: count, isLoading } =
        trpc.integrations.rf.countInvoices.useQuery();

    const { mutate: resyncInvoices } =
        trpc.integrations.rf.syncInvoices.useMutation({
            onSuccess: () => {
                notify.success("Started invoices and tags synchronization");
            },
            onError: () => {
                notify.error(
                    `Failed to start invoices and tags synchronization`,
                );
            },
        });

    return (
        <div className="relative">
            <CardWidget
                icon={
                    <Image
                        src="/images/request-logo.svg"
                        alt="Request Finance Logo"
                        width="36"
                        height="36"
                    />
                }
                title={"Request Finance"}
                href=""
                description={
                    <div className="flex items-center gap-1">
                        <span className="font-bold text-primary">
                            {isLoading ? (
                                <Spin size="small" />
                            ) : count < 100 ? (
                                count
                            ) : (
                                "100+"
                            )}
                        </span>
                        <span>synchronized invoices</span>
                    </div>
                }
            />
            <Button
                className="absolute right-1 top-1 cursor-pointer border-none shadow-none"
                onClick={() => resyncInvoices()}
            >
                <PopupCard
                    trigger={<ArrowPathIcon className="size-5" />}
                    sideValue="left"
                    className="cursor-pointer"
                >
                    Resync invoices and tags
                </PopupCard>
            </Button>
        </div>
    );
};
